import React, { useEffect, useState } from 'react';
import p_nav_previous from '../../../Assets/Images/p_nav_previous.svg';
import wallet_banner from '../../../Assets/Images/wallet_banner.png';
import point_icons from '../../../Assets/Images/ping_coin.png';
import "./wallet.css";
import { FaPlus } from "react-icons/fa6";
import { MdOutlineArrowForwardIos } from "react-icons/md";

import { useNavigate } from 'react-router-dom';
import { showToast } from '../../../Components/toastConfig/ToastConfig';
import NodeaxiosInstance from '../../../Services/nodeaxios';
import AddPingsOffcanvas from '../../../Components/offCanvas/addPingsOffcanvas';
import WalletTransactionCard from '../../../Components/cards/walletTransactionCard';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';

// <LuArrowUpRight />
// <LuArrowDownLeft />

const Wallet = () => {
    const navigate = useNavigate();
    const [data, setData] = useState();
    const [transactionHistory, setTransactionHistory] = useState([]);
    const [vendorTokens, setVendorTokens] = useState([]);
    const [isPageLoaded, setIsPageLoaded] = useState(false)
    const [isOpen, setIsOpen] = useState(false);


    useEffect(() => {
        fetchData();
        fetchTransactionHistory()
        fetchVendorTokens()
    }, [])
 

    const fetchData = async () => {
        try {
            let respones = await NodeaxiosInstance.get("/wallet");
            if (respones.status == 200) {
                console.log("wallet data", respones.data);
                setData(respones?.data);
            }
        } catch (error) {
            console.error("Error fetching wallet data:", error);
            showToast("Failed to fetch wallet data. Please try again later.");
        }
    }

    const fetchVendorTokens = async () => {
        try {
            let respones = await NodeaxiosInstance.get("/wallet/shared-pings");
            if (respones.status == 200) {
                console.log("wallet- shared-pings", respones.data);
                setVendorTokens(respones?.data?.rewards?.slice(0, 3) || []);
            }
        } catch (error) {
            console.error("Error fetching wallet-shared-pings data:", error);
            showToast("Failed to fetch wallet shared pings. Please try again later.");
        }
    }

    const fetchTransactionHistory = async () => {
        try {
            let respones = await NodeaxiosInstance.get("/wallet/wallet-trasactions");
            if (respones.status == 200) { 
                setTransactionHistory(respones?.data?.userWalletTransactions?.slice(0, 6) || []);
            }
            setIsPageLoaded(true)
        } catch (error) {
            console.error("Error fetching wallet-transactions data:", error);
            showToast("Failed to fetch wallet transactions . Please try again later.");
        }
    }
    const toggleOffcanvas = () => {
        setIsOpen(!isOpen);
        if (!isOpen) {
            fetchData();
        }
    }

    return (

        <>
            {isPageLoaded ?
                <div>
                    <div className="d-flex justify-content-between align-items-center p-3 p-navbar bg-white  offcanvas-parentType1">
                        <div className="d-flex justify-content-between align-items-center" onClick={() => navigate(-1)}>
                            <img src={p_nav_previous} alt="Previous Button" role="button" width={'24px'} height={'16px'} />
                            <div className='ff-balooPaaji2-bold fs-20 ms-2 ps-1'>My wallet</div>
                        </div>
                    </div>
                    <div className='scroller-style-y pb-5'>
                        <div className="wallet_banner_container position-relative ">
                            <img src={wallet_banner} alt="Wallet Banner" className=" w-100" />
                            <img src={point_icons} alt="Point Icons" className="wallet_ping_point position-absolute" />
                        </div>
                        <div className='d-flex  justify-content-center align-items-center mt-2'>
                            <div className='text-center'>
                                <h5 className='ping_point'>{data?.walletPings || 0} </h5>
                                <p className='ff-poppins-semiBold fs-13 p-0 m-0 mb-2' >Pings</p>
                                <button className='add_ping_btn' onClick={() => toggleOffcanvas()}><FaPlus /> Add Pings</button>
                                
                            </div>
                        </div>

                        <div className='vendor_wallet_container'>
                            <div className='vendor_wallet_header'>
                                <span className='primary-text'>Shared Pingles Token</span>
                                {vendorTokens?.length > 0 && <span className='secondary-text-1' onClick={() => navigate('/vendors-token')}>View more <MdOutlineArrowForwardIos /></span>}

                            </div>
                            {vendorTokens?.length > 0 ?
                                vendorTokens.map((item, index) => (
                                    <div key={item.vendor_id || index} className='vendor_wallet_box'>

                                        <div className='d-flex justify-content-between w-100 vendor_info'   >
                                            <div className='d-flex justify-content-between'>
                                                <img
                                                    src={item?.vendor_logo || 'https://pingle.s3.ap-south-1.amazonaws.com/uploads/vendor/profile/68edda1b86009.png'}
                                                    alt="Vendor Logo"
                                                    className='vendor_logo'
                                                />

                                                <div className='ms-2 '>
                                                    <p className='vendor_token_vendor_name'>
                                                        {item?.vendor_company_name || 'Chop chop'}
                                                        {item?.hub_name && <span className='vendor_token_hub_name'> ({item?.hub_name}) </span>}
                                                    </p>
                                                    <p className='vendor_ping_point'>
                                                        {item?.balance || 0} Tokens
                                                    </p>
                                                    <p onClick={() => navigate(`/vendor-wallet-history/${item?.vendor_id}`)}
                                                        className='action_btn'> History </p>

                                                </div>
                                            </div>
                                            <button className='ping_redeem_btn mt-4' onClick={() => navigate(`/vendor/${item?.vendor_id}`)}>
                                                Redeem <MdOutlineArrowForwardIos className='ms-2' />
                                            </button>
                                        </div>
                                    </div>
                                ))
                                :
                                <div className="d-flex justify-content-center mt-5 mb-5 align-items-center w-100"  >
                                    <span className="ff-poppins-Regular fs-14">
                                        No Vendors Available For Token Booking
                                    </span>
                                </div>
                            }
                        </div>

                        <div className='vendor_wallet_container'>
                            <div className='vendor_wallet_header'>
                                <span className='primary-text'>Transaction History</span>
                                {transactionHistory?.length > 0 && <span className='secondary-text-1' onClick={() => navigate('/wallet-history')}>View more <MdOutlineArrowForwardIos /></span>}
                            </div>

                            {
                                transactionHistory?.length > 0 ?
                                    transactionHistory?.map((item, index) => (
                                        <WalletTransactionCard key={index} item={item} />
                                    )) :
                                    <div className="d-flex justify-content-center mt-5 mb-5 align-items-center w-100"  >
                                        <span className="ff-poppins-medium fs-13">
                                            No Transaction Found
                                        </span>
                                    </div>
                            }
                        </div>

                        {isOpen &&
                            <AddPingsOffcanvas toggleOffcanvas={toggleOffcanvas} isOpen={isOpen} />
                        }
                    </div>
                </div>
                :
                <div style={{ padding: '15px', backgroundColor: '#9e9c9c26' }}>
                    <Skeleton width={350} height={50} style={{ marginBottom: 20 }} />
                    <div className="text-center mb-4">
                        <Skeleton height={80} width={80} borderRadius={16} style={{ margin: "0 auto 16px" }} />
                        <Skeleton width={120} height={28} style={{ margin: "10px auto" }} />
                        <Skeleton width={80} height={16} style={{ margin: "8px auto" }} />
                        <Skeleton width={140} height={40} borderRadius={10} style={{ margin: "16px auto" }} />
                    </div>

                    <div className=" p-3 mb-3">
                        <Skeleton width={150} height={18} style={{ marginBottom: 12 }} />

                        <div className="d-flex align-items-center justify-content-between">
                            <Skeleton width={50} height={50} borderRadius={10} />

                            <div style={{ flex: 1, marginLeft: 12 }}>
                                <Skeleton width={120} height={16} />
                                <Skeleton width={90} height={14} style={{ marginTop: 6 }} />
                            </div>

                            <Skeleton width={80} height={32} borderRadius={20} />
                        </div>
                    </div>

                    <div className=" p-3">
                        <Skeleton width={180} height={18} style={{ marginBottom: 12 }} />

                        {[1, 2, 3].map((item) => (
                            <div
                                key={item}
                                className="d-flex align-items-center justify-content-between mb-3"
                            >
                                <Skeleton circle width={40} height={40} />

                                <div style={{ flex: 1, marginLeft: 12 }}>
                                    <Skeleton width={140} height={16} />
                                    <Skeleton width={120} height={14} style={{ marginTop: 6 }} />
                                </div>

                                <Skeleton width={50} height={16} />
                            </div>
                        ))}
                    </div>
                </div>
            }
        </>
    );
};

export default Wallet; 